export default "/assets/images/home-wrecker-small.f6498722f2a0999b.png";